export default "__VITE_ASSET__CyLEZgaD__"